import { useSyncExternalStore, type ReactNode } from 'react'

// PLAN.md §7.11 — Trading Grounds is desktop-only in v1.
const MIN_VIEWPORT_PX = 1024

function subscribe(cb: () => void): () => void {
  window.addEventListener('resize', cb)
  return () => window.removeEventListener('resize', cb)
}

function getSnapshot(): number {
  return window.innerWidth
}

function getServerSnapshot(): number {
  return MIN_VIEWPORT_PX
}

export function DesktopOnlyGate({ children }: { children: ReactNode }) {
  const width = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
  if (width < MIN_VIEWPORT_PX) {
    return (
      <main className="min-h-screen flex items-center justify-center px-6 text-center">
        <p className="text-body text-grey max-w-sm">
          Open on desktop — Trading Grounds needs a wider screen.
        </p>
      </main>
    )
  }
  return <>{children}</>
}
